<template>
	<div class="wrappe-banner" :class="{ 'no-margin': !bannerVisible }">
		<v-layout class="banner" wrap>
			<v-flex xs12>
				<v-layout wrap class="container">
					<v-flex xs12 class="mobile wrapper-btn-mobile">
						<button class="btn-home">bodega.net</button>
					</v-flex>
					<v-flex xs12 md6>
						<div class="wrapper-image">
							<button @click="goToHome">
								<img 
									:src="`${$S3}logo-mibodega-white.png`"
									alt="logo"
									height="31"
								/>
							</button>
						</div>
						<div class="mb-5">
							<p class="mb-0 text-information">BIENVENIDO eres <br class="mobile"> parte <br class="desktop"/>
								de los primeros<br class="mobile"/> <span class="text-green">{{ numberCoupon }} NEGOCIOS VALIDADOS</span></p>
						</div>
						<div class="wrapper-btns">
							<div class="wrapper-link mr-3">
								<div
									v-if="disabledRegisterApp"
									class="disabled-btn"></div>
								<a 
								:href="disabledRegisterApp ? '#' : '#generate-app'"
								class="link">ACTIVA TU APP</a>
							</div>
							<div class="wrapper-link">
								<div
									v-if="disabledPayment" 
									class="disabled-btn"></div>
								<a 
								:href="disabledPayment ? '#' : linkPayment"
								class="link" target="_blank">REALIZAR PAGO</a>
							</div>
						</div>
					</v-flex>
					<v-flex xs12 md6>
						<div class="wrapper-links">
							<button class="btn-home" @click="goToHome">bodega.net</button>
							<a 
								:href="linkGooglePlay" 
								class="link-google"
								target="_blank">
								<img 
									:src="`${$S3}icon-google.png`" 
									alt="google paly"
									height="56px">
							</a>
						</div>
						<div class="mobile">
							<div class="mobile">
								<a 
									:href="linkGooglePlay" 
									class="link-google mobile"
									target="_blank">
									<img 
										:src="`${$S3}icon-google.png`" 
										alt="google play"
										height="56px">
								</a>
							</div>
							<img 
								:src="`${$S3}phone-app-screen-footer-min.png`" 
								alt="mobile"
								class="image-mobile"
								width="100%">
						</div>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
	</div>
</template>
<script>

function goToHome() {
	this.goTo('page-home');
}

function data() {
	return {
		linkGooglePlay: process.env.LINK_GOOGLE_PLAY,
		linkPayment: process.env.LINK_PAYMENT,
		numberCoupon: process.env.NUMBER_COUPON,
	};
}

export default {
	name: 'banner',
	data,
	methods: {
		goToHome,
	},
	props: {
		bannerVisible: {
			default: true,
			type: Boolean,
		},
		disabledRegisterApp: {
			type: Boolean,
			default: false,
		},
		disabledPayment: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
<style lang="scss" scoped>
	.banner {
		background-image: url('https://mibodega.s3-sa-east-1.amazonaws.com/banner-app-2.png');
		background-size: cover;
		background-position: bottom;
		height: 445px;
		padding: 36px 7% 0 7%;

		@media (max-width: 934px) {
			background-image: url('https://mibodega.s3-sa-east-1.amazonaws.com/banner-app-mobile-2.png');
			height: 823px;
			padding: 73px 7% 0 7%;
		}
	}

	.wrappe-banner {
		padding-top: 68px;

		&.no-margin {
			padding-top: 0px;
		}
	}

	.wrapper-image {
		margin-bottom: 84px;

		@media (max-width: 934px) {
			margin-bottom: 35px;
			text-align: center;
		}
	}

	.text-information {
		color: color(white);
		font-size: size(large29);
		font-weight: 600;

		@media (max-width: 934px) {
			font-size: size(medium20);
			text-align: center;
		}
	}

	.text-green {
		color: color(green-link);
	}

	.link {
		background: color(white);
		border-radius: 7px;
		display: inline-block;
		color: color(title-green);
		font-size: size(medium16);
		font-weight: 600;
		padding: 8px;
		text-decoration: none;
		text-align: center;

		@media (max-width: 934px) {
			font-size: size(medium);
			padding: 18px 0;
		}
	}

	.btn-home {
		background-color: rgba(2, 151, 155, 0.68);
		border: 2px solid color(back-green);
		border-radius: 7px;
		color: color(white);
		font-weight: 600;
		padding: 8px 0;
		width: 138px;
	}

	.link-google {
		display: inline-block;

		&.mobile {
			text-align: right;
		}
	}

	.wrapper-links {
		text-align: right;
		@media (max-width: 934px) {
			display: none;
		}
	}

	.desktop {
		@media (max-width: 934px) {
			display: none;
		}
	}

	.mobile {
		display: none;

		@media (max-width: 934px) {
			display: block;
		}
	}

	.wrapper-btns {
		display: flex;

		@media (max-width: 934px) {
			text-align: center;
		}
	}

	.wrapper-btn-mobile {
		text-align: center;
	}

	.image-mobile {
		margin-top: -36px;
	}

	.banner-information {
		color: color(white);
		margin-top: 16px;
	}

	.disabled-btn {
		background-color: color(white);
		border-radius: 7px;
		bottom: 0;
		cursor: not-allowed;
		left: 0;
		opacity: 0.5;
		position: absolute;
		right: 0;
		top: 0;
	}

	.wrapper-link {
		position: relative;
	}
</style>


// WEBPACK FOOTER //
// src/components/generate-app/banner.vue